var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-container',[_c('g-contents',[_c('am-xy-chart-2',{attrs:{"refName":"srline","chart-data":_vm.chartData,"filter":_vm.filter,"series-type":"LineSeries"},on:{"hit":_vm.onHit}}),_vm._v(" "),_c('am-xy-chart-2',{attrs:{"refName":"srline","chart-data":_vm.chartData,"filter":_vm.filter,"series-type":"ColumnSeries"},on:{"hit":_vm.onHit}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43a4a2eb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/sample/AmChartSample.vue
// module id = null
// module chunks = 